import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, } from '@angular/router';
import { UserStateService } from '../services/user-state.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private userStateService: UserStateService,
    private router: Router
  ) { }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    // Wait for user info to be initialized if not already
    await this.userStateService.waitForInitialization();

    const userInfo = this.userStateService.getCurrentUserInfo();

    // Handle new login - force reload
    if (userInfo && 'new_login' in userInfo && userInfo['new_login'] === true) {
      window.location.reload();
      return false;
    }

    // Check if user is authenticated
    if (this.userStateService.isAuthenticated()) {
      return true;
    } else {
      // Don't show "session expired" here - we can't distinguish "never logged in" from
      // "session expired" on initial load. Session expired is only shown when we get 401
      // from an API call (via AuthInterceptor) - i.e. when session was invalidated elsewhere.

      this.router.navigate(['/account'], {
        queryParams: {
          returnUrl: state.url ?? undefined,
          ...(route.queryParams['sso_error'] && { sso_error: route.queryParams['sso_error'] }),
        },
      });
      return false;
    }
  }
}
